const socialClubStore = {
	state: {
		// post
		hasPost: false,
		hasPostImage: false,

		// edit comment
		commentHasChanges: false,
		commentImageHasChanges: false,

		// comment
		hasCommentImage: false,
		hasComment: false,
	},
	mutations: {
		// post
		setHasPost(state, hasChange) {
			state.hasPost = hasChange;
		},
		setHasPostImage(state, hasChange) {
			state.hasPostImage = hasChange;
		},

		// comment
		setHasComment(state, hasComment) {
			state.hasComment = hasComment;
		},
		setHasCommentImage(state, hasImage) {
			state.hasCommentImage = hasImage;
		},

		// edit comment
		setCommentHasChange(state, hasChange) {
			state.commentHasChanges =  hasChange;
		},
		setCommentImageHasChanges(state, hasChange) {
			state.commentImageHasChanges = hasChange;
		},
		resetFlags(state) {
			// post
			state.hasPost = false;
			state.hasPostImage = false;

			// edit comment
			state.commentHasChanges = false;
			state.commentImageHasChanges = false;

			// comment
			state.hasCommentImage = false;
			state.hasComment = false;
		},
		resetEditComments(state) {
			state.commentHasChanges = false;
			state.commentImageHasChanges = false;
		},
		resetEditPost(state) {
			state.postHasChanges = false;
			state.postImagesHasChanges = false;
		},
	},
	getters: {
		getSocialClubState(state) {
			return state;
		}
	}
}

export default socialClubStore;